const PressReleaseArticleHero = {
  displayField: 'header',
  name: 'Press Release Article Hero',
  description: 'Contentful new schema template',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyText',
      name: 'Body Text',
      type: 'Text',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'eyebrow',
      name: 'Eyebrow',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'author',
      name: 'Author',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'publicationDate',
      name: 'Publication Date',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [
        {
          regexp: { pattern: '^\\d{4}\\-(\\d{2})\\-(\\d{2})', flags: null },
          message: 'Please use the format: YYYY-MM-DD'
        }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'image',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: true,
      linkType: 'Asset'
    },
    {
      id: 'img',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'ctaUrl',
      name: 'CtaUrl',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'PressReleaseArticleHero',
    version: 19,
    updatedAt: '2023-08-03T14:25:23.996Z'
  }
};
export default PressReleaseArticleHero;